import React from 'react';
import classes from './FormFields.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle} from '@fortawesome/free-solid-svg-icons';

const formFields = props => {
   
    let fields = null;
    switch (props.elementType) {
        case 'input':
            fields = (
                <div>
                    <label htmlFor={props.id} className={classes.formLabel}> {props.label} </label><br/>
                    <input {...props.config} className={classes.formInputs} value={props.value} 
                     onBlur={props.blur} onChange={props.change} 
                     style={{border: props.isDirty && !props.isValid ? '2px solid red' : null}}
                     />
                     
                   {props.isDirty ? props.isValid ?
                   <span className={classes.span + ' ' + classes.valid}>
                      <FontAwesomeIcon icon={faCheckCircle} color="green" size="lg" 
                       className={classes.faIcon} />
                       </span>
                    : <span className={classes.span + ' ' + classes.invalid}> 
                        <FontAwesomeIcon icon={faTimesCircle} color="white" size="lg"
                         style={{backgroundColor:'red',borderRadius:'50%'}} id={classes.facross} 
                         className={classes.faIcon}/>
                       </span>
                   : null
                   }
                </div>
            )
            break;
        case 'button':
            fields = (
                <div style={{marginTop: '20px'}}>
                    <button {...props.config} className={classes.signupBtn} onClick={props.click} disabled={!props.isFormValid}>
                        {props.label}
                    </button>
                </div>
            )
            break;
        default:
            break;
    }
    
    return fields;
    
}

export default formFields;